import { create } from 'zustand';

type ExternalToolActivityState = {
  activeChatIds: Record<string, boolean>;
  setChatActivity: (params: { chatId: string; active: boolean }) => void;
};

export const useExternalToolActivityStore = create<ExternalToolActivityState>(
  (set) => ({
    activeChatIds: {},
    setChatActivity: ({ chatId, active }) =>
      set((state) => {
        const isCurrentlyActive = Boolean(state.activeChatIds[chatId]);
        if (isCurrentlyActive === active) {
          return state;
        }

        const nextActiveChatIds = { ...state.activeChatIds };
        if (active) {
          nextActiveChatIds[chatId] = true;
        } else {
          delete nextActiveChatIds[chatId];
        }
        return { activeChatIds: nextActiveChatIds };
      }),
  }),
);

export function useIsExternalToolChatActive(chatId: string): boolean {
  return useExternalToolActivityStore((state) =>
    Boolean(state.activeChatIds[chatId]),
  );
}
